<nz-header id="systoolbar">
  <div class="app-header">
    <ul class="ul-head">
      <li style="padding-left:20px">
        <div class="app-header-ul-item">
          <div class="default__header-logo">
            <a routerLink='/'>
              <div class="default__header-logo-expanded"></div>
              <div class="default__header-logo-collapsed"></div>
            </a>
          </div>
        </div>
      </li>
      <li>
        <div class="app-header-ul-item dd" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
          <nz-avatar [nzSize]="'small'" [nzSrc]="settings.user.avatar|src"></nz-avatar>
          <span>{{settings.user.name}}</span>
        </div>
      </li>
      <li class="head-item-setting">
        <div class="app-header-ul-item" nz-dropdown [nzDropdownMenu]="setting" nzTrigger="click">
          <i nz-icon nzType="setting" nzTheme="outline"></i>
        </div>
      </li>

      <li>
        <div class="app-header-ul-item header-trigger_i" (click)="toggleCollapsedSidebar()">
          <i class="trigger" nz-icon [nzType]="settings.layout.collapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </div>
      </li>
      <li class="head-item-lock">
        <div class="app-header-ul-item"><i nz-icon nzType="lock" nzTheme="outline"></i></div>
      </li>
    </ul>
    <!-- <div class="head-item-search">
      <nz-input-group #search class="header-search" [nzPrefix]="suffixIconSearch">
        <input type="text" nz-input placeholder="{{'menu.search.placeholder'|translate}}" (focus)="onSearchFocus()"
          (blur)="onSearchBlur()" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i *ngIf="!searchEditing" nz-icon nzType="search"></i>
        <i *ngIf="searchEditing" nz-icon nzType="edit"></i>
      </ng-template>
    </div>
    -->
    <layout-header-system-buttom *ngIf="sysapi.isWebkitClient"></layout-header-system-buttom>
  </div>
  <nz-dropdown-menu #setting="nzDropdownMenu">
    <ul nz-menu class="dropdown-menu_200">

      <li nz-menu-item (click)="setFullScreen()">
        <i nz-icon [nzType]="fullscreenStatus ? 'fullscreen-exit' : 'fullscreen'"></i>{{(fullscreenStatus ? 'menu.fullscreen.exit'
        : 'menu.fullscreen') | translate}}
      </li>
      <li nz-menu-item (click)="clearLocaCach()"><i nz-icon nzType="clear"
          nzTheme="outline"></i>{{'menu.clear.local.storage'|translate}}</li>
      <li nz-menu-item *ngIf="settings.app.showLang">
        <div nz-dropdown [nzDropdownMenu]="menu" *ngIf="settings.app.showLang">
          <i nz-icon nzType="global"></i>{{ 'menu.lang' | translate}}
          <i nz-icon nzType="down"></i>
        </div>
        <nz-dropdown-menu #menu="nzDropdownMenu" nzPlacement="bottomRight">
          <i *ngIf="!settings.app.showLang" nz-dropdown nz-icon nzType="global"></i>
          <ul nz-menu>
            <li nz-menu-item *ngFor="let item of langs" [nzSelected]="item.code === settings.layout.lang"
              (click)="changeLang(item.code)"><span style="font-size: 12px;">{{item.sortname}}</span>{{" "+item.text}}
            </li>
          </ul>
        </nz-dropdown-menu>

      </li>

      <li nz-menu-item>
        <div nz-dropdown [nzDropdownMenu]="changeThemeMenu">
          <i nz-icon nzType="skin"></i>{{ 'menu.changeTheme' | translate}}
          <i nz-icon nzType="down"></i>
        </div>
        <nz-dropdown-menu #changeThemeMenu="nzDropdownMenu" nzPlacement="bottomRight">
          <ul nz-menu>
            <li nz-menu-item *ngFor="let item of themes" [nzSelected]="item.name === settings.layout.theme"
              (click)="changeTheme(item.name)"><span style="font-size: 12px;"></span>{{" "+item.text}}
            </li>
          </ul>
        </nz-dropdown-menu>

      </li>
    </ul>
  </nz-dropdown-menu>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu nzSelectable class="dropdown-menu_160">
      <li nz-menu-item [nzMatchRouter]="true"  [routerLink]="'/account/center'"><i nz-icon nzType="user"></i>{{'menu.account.center'|translate}}</li>
      <li nz-menu-item [nzMatchRouter]="true"  [routerLink]="'/account/settings'"><i nz-icon nzType="setting"></i>{{'menu.account.settings'|translate}}</li>
      <li nz-menu-item (click)="logout()"><i nz-icon nzType="logout"></i>{{'menu.account.logout'|translate}}</li>
    </ul>
  </nz-dropdown-menu>
  <nz-dropdown-menu nzTrigger="click" nzPlacement="bottomRight">
    <div class="alain-default__nav-item" nz-dropdown>
      <i nz-icon type="setting"></i>
    </div>
    <div nz-menu style="width:200px;">
      <div nz-menu-item>
        aaaa
      </div>
      <div nz-menu-item>
        bbb
      </div>
      <div nz-menu-item>

      </div>
    </div>
  </nz-dropdown-menu>
</nz-header>